import { Colors, FontWeights, Radii, Shadows, Space, TextStyles } from '../../types';

const baseStyle = {
  list: {
    apply: `textStyles.${TextStyles.UI_DEFAULT}`,
  },
  link: {
    display: 'inline-flex',
    gap: Space.SPACE_1,
    fontWeight: FontWeights.NORMAL,
    '&[aria-current=page]': {
      textDecoration: 'none',
      textDecorationColor: 'transparent',
      color: Colors.TEXT_EMPHASIS,
      fontWeight: FontWeights.MEDIUM,
    },
    '&:not([aria-current=page])': {
      _hover: {
        color: Colors.TEXT_EMPHASIS,
        textDecoration: 'underline',
        textDecorationThickness: '1px',
        textUnderlineOffset: '3px',
        textDecorationColor: 'color-mix(in srgb, currentColor 72%, transparent)',
      },
      _focusVisible: {
        boxShadow: Shadows.OUTLINE,
        rounded: Radii.BASE,
      },
    },
  },
  separator: {
    color: Colors.ICON_DEFAULT,
    mx: Space.SPACE_1,
    '&:has(svg)': {
      fontSize: '.75em',
      alignSelf: 'baseline',
    },
  },
};

export const breadcrumbTheme = {
  baseStyle,
};
